import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Datagrid } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils';

const defaultColumnStyle = getColumnStyle(250);

export const DatagridStyled = styled(Datagrid)(({ theme }) => ({
  border: 'none',
  '& .MuiTableCell-root': { padding: '8px 16px', verticalAlign: 'middle', border: 'none' },
  '& .MuiTableCell-head': {
    verticalAlign: 'middle',
    padding: '17px 16px',
    backgroundColor: grey[50],
  },
  '& .RaDatagrid-headerCell': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& .column-originId': defaultColumnStyle,
  '& .column-createdAt': defaultColumnStyle,
  '& .column-status': defaultColumnStyle,
}));
